import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import api from '../services/api';
import './FaireUnDon.scss';

const FaireUnDon = () => {
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState('');
  const [donationType, setDonationType] = useState('unique');
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const predefinedAmounts = [5000, 10000, 25000, 50000, 100000, 250000];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const amount = selectedAmount || customAmount;

    if (!amount || amount < 1000) {
      setError('Veuillez sélectionner ou saisir un montant valide (minimum 1000 FCFA).');
      return;
    }

    if (!phone) {
      setError('Veuillez saisir votre numéro de téléphone.');
      return;
    }

    const normalizedPhone = phone.replace(/\D/g, '').replace(/^225/, '');

    if (!name) {
      setError('Veuillez saisir votre nom.');
      return;
    }

    setError('');
    setLoading(true);

    try {
      const { data } = await api.post('/payment/donate', {
        amount: parseFloat(amount),
        phone: normalizedPhone,
        name,
      });

      if (data.success && data.url) {
        window.location.href = data.url;
      } else {
        setError(data.message || 'Erreur lors de l\'initialisation du paiement.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de l\'initialisation du paiement.');
    }

    setLoading(false);
  };

  return (
    <div className="don-page">
      <PageHeader 
        title="Faire un Don" 
        subtitle="Soutenez l'excellence africaine"
        breadcrumb={['Accueil', 'Faire un don']}
      />

      <div className="don-container">
        <div className="don-intro">
          <h2>Votre contribution fait la différence</h2>
          <p>
            Chaque don contribue à former une nouvelle génération de leaders africains. 
            Votre soutien permet de financer nos programmes de mentorat, de formation et d'accompagnement.
          </p>
        </div>

        <div className="don-grid">
          <div className="don-form-wrapper">
            <form onSubmit={handleSubmit} className="don-form">
              <div className="donation-type">
                <h3>Type de don</h3>
                <div className="type-options">
                  <label className={`type-option ${donationType === 'unique' ? 'active' : ''}`}>
                    <input
                      type="radio"
                      name="donationType"
                      value="unique"
                      checked={donationType === 'unique'}
                      onChange={(e) => setDonationType(e.target.value)}
                    />
                    <span>Don unique</span>
                  </label>
                  <label className={`type-option ${donationType === 'mensuel' ? 'active' : ''}`}>
                    <input
                      type="radio"
                      name="donationType"
                      value="mensuel"
                      checked={donationType === 'mensuel'}
                      onChange={(e) => setDonationType(e.target.value)}
                    />
                    <span>Don mensuel</span>
                  </label>
                </div>
              </div>

              <div className="donation-amount">
                <h3>Montant du don (FCFA)</h3>
                <div className="amount-grid">
                  {predefinedAmounts.map((amount) => (
                    <button
                      key={amount}
                      type="button"
                      className={`amount-btn ${selectedAmount === amount ? 'active' : ''}`}
                      onClick={() => {
                        setSelectedAmount(amount);
                        setCustomAmount('');
                      }}
                    >
                      {amount.toLocaleString()} F
                    </button>
                  ))}
                </div>

                <div className="custom-amount">
                  <label htmlFor="customAmount">Autre montant</label>
                  <input
                    type="number"
                    id="customAmount"
                    value={customAmount}
                    onChange={(e) => {
                      setCustomAmount(e.target.value);
                      setSelectedAmount(null);
                    }}
                    placeholder="Entrez un montant"
                    min="1000"
                  />
                </div>
              </div>

              <div className="donor-info">
                <h3>Vos informations</h3>
                <div className="form-group">
                  <label htmlFor="donorName">Nom complet *</label>
                  <input
                    type="text"
                    id="donorName"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    placeholder="Votre nom"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="donorPhone">Numéro de téléphone (Mobile Money) *</label>
                  <input
                    type="tel"
                    id="donorPhone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                    placeholder="Ex: 01010101"
                  />
                  <p style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>
                    Numéro pour recevoir la demande de paiement (Orange, MTN, Moov, Wave...)
                  </p>
                </div>
              </div>

              {error && (
                <div className="don-error" style={{ color: '#dc3545', fontSize: '14px', marginBottom: '15px' }}>
                  {error}
                </div>
              )}

              {success && (
                <div className="don-success" style={{ color: '#28a745', fontSize: '14px', marginBottom: '15px', padding: '10px', backgroundColor: '#e8f5e9', borderRadius: '5px' }}>
                  {success}
                </div>
              )}

              <button type="submit" className="don-submit-btn" disabled={(!selectedAmount && !customAmount) || loading}>
                {loading ? 'Initialisation...' : 'Procéder au paiement'}
              </button>

              <p className="secure-note">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                Paiement sécurisé
              </p>
            </form>
          </div>

          <div className="don-impact">
            <h3>Impact de votre don</h3>
            
            <div className="impact-item">
              <div className="impact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5"/>
                  <path d="M2 12l10 5 10-5"/>
                </svg>
              </div>
              <div className="impact-content">
                <h4>5 000 FCFA</h4>
                <p>Finance une session de mentorat pour un étudiant</p>
              </div>
            </div>

            <div className="impact-item">
              <div className="impact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                </svg>
              </div>
              <div className="impact-content">
                <h4>25 000 FCFA</h4>
                <p>Offre un kit de formation complet à un bénéficiaire</p>
              </div>
            </div>

            <div className="impact-item">
              <div className="impact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div className="impact-content">
                <h4>100 000 FCFA</h4>
                <p>Parraine un étudiant pour un programme complet</p>
              </div>
            </div>

            <div className="other-ways">
              <h4>Autres façons de contribuer</h4>
              <p>
                Vous pouvez également nous soutenir en devenant partenaire ou en nous contactant 
                pour des opportunités de collaboration.
              </p>
              <Link to="/contact" className="contact-link">
                Nous contacter
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaireUnDon;
